import { push } from 'connected-react-router';

import type { MenuActions } from 'src/app/components/PageSections/CardItemOverflowMenuWrapper';
import { accountPage } from 'src/app/router/paths';
import { openChat } from 'src/app/state/slices/chat';
import type { Dispatch } from 'src/app/state/store';
import type { CTA, MedicationMenuActionProps } from 'src/app/types';
import { CTATypes, GENERAL_CONTACT_INFO, IS_MOBILE, POPUP_MENU_LABELS, REFILL_STATUSES } from 'src/consts';

type GetMenuActionForMedication = (obj: MedicationMenuActionProps) => MenuActions;
export const getMenuActionForMedication: GetMenuActionForMedication = ({
  trackArchiveMedication,
  trackOpenMedicationAction,
  patientMedicationId,
  medicationId,
  setOverflowHidden,
  dispatchArchive,
  dispatchGetAllHomescreenItems,
  dispatchGoToMedicationDetails,
  isArchivedSection,
  setAnimationState,
  menuLabel,
  prescriptionId,
  refillStatusText,
  dispatchSetShowNewArchivedPageModal,
  dispatchSetMedicationLoadingState,
  type,
}) => {
  const menuActions = {
    openMenuAction: () => trackOpenMedicationAction({ patientmedication_id: patientMedicationId }),
    items: [
      {
        label: POPUP_MENU_LABELS.medicationDetails,
        analyticsPayload: null,
        action: async () => {
          dispatchGoToMedicationDetails(prescriptionId, type);
        },
      },
    ],
  };

  if (!isArchivedSection) {
    menuActions.items.push({
      label: menuLabel,
      analyticsPayload: { patientmedication_id: patientMedicationId },
      action: async () => {
        setOverflowHidden(true);
        dispatchSetMedicationLoadingState(patientMedicationId, true);
        const response = await dispatchArchive(patientMedicationId, isArchivedSection);
        dispatchSetShowNewArchivedPageModal(true);
        if (response) {
          await dispatchGetAllHomescreenItems(isArchivedSection);

          trackArchiveMedication({
            source: 'Overflow Menu',
            patientmedication_id: patientMedicationId,
            medication_id: medicationId,
            is_expired: refillStatusText === REFILL_STATUSES.EXPIRED,
          });

          setAnimationState({ collapse: true, expand: false });
          setOverflowHidden(false);
        }
        dispatchSetMedicationLoadingState(patientMedicationId, false);
      },
    });
  }
  // Remove empty objects from menuActions in order to prevent undesirable whitespace in rendering.
  menuActions.items = menuActions.items.filter(item => item);

  return menuActions;
};

export const CTATypesToTextMap: { [ctaType: string]: string } = {
  [CTATypes.showYourDoctor]: 'Show Your Doctor',
  [CTATypes.callYourDoctor]: 'Contact your doctor',
  [CTATypes.callYourPharmacy]: 'Contact your pharmacy',
  [CTATypes.needInsurance]: 'Update insurance',
  [CTATypes.showInsuranceList]: 'Update insurance',
  [CTATypes.chatWithUs]: 'Contact us',
  [CTATypes.requestRefill]: 'Request a refill',
  [CTATypes.processRefill]: 'Request a refill',
  [CTATypes.rescheduleOrder]: 'Reschedule Order',
  [CTATypes.scheduleDelivery]: 'Schedule Delivery',
};

export const ctaAction = (cta: CTA, dispatch: Dispatch) => {
  if (
    (cta.action.type === CTATypes.callYourDoctor || cta.action.type === CTATypes.callYourPharmacy) &&
    cta.action.metadata?.phone
  ) {
    window.location.href = `tel:${cta.action.metadata.phone}`;
  } else if (cta.action.type === CTATypes.showInsuranceList || cta.action.type === CTATypes.needInsurance) {
    dispatch(push(accountPage.toPath()));
  } else if (cta.action.type === CTATypes.chatWithUs) {
    if (IS_MOBILE) {
      window.location.href = `sms:${GENERAL_CONTACT_INFO.CAPSULE_TEXT_NUMBER}`;
    } else {
      dispatch(openChat());
    }
  }
};
